module.exports = __webpack_public_path__ + "img/prestatieafspraken.6d272c4f.svg";